import { LogTimeUnit } from 'src/pages/Log/shared';

export enum LogTypeEnum {
  DETECTION = 'detection',
  ADUIT = 'audit',
  INLINETRACKING = 'inlineTracking',
  QUARANTINE = 'quarantine',
  APIINTEGRATION = 'apiIntegration',
  URLTRACKING = 'urlTracking',
}

//Compared with ServiceNameEnum, there is one less TeamsChat attribute
export enum QuarantineLogTypeEnum {
  Exchange = 'exchange',
  SharePoint = 'sharepoint',
  OneDrive = 'onedrive',
  Dropbox = 'dropbox',
  GoogleDrive = 'googledrive',
  Box = 'box',
  Gmail = 'gmail',
  GmailInline = 'gmail_inline',
  Teams = 'teams',
  ExchangeServer = 'exchangeserver',
  SalesforceSandbox = 'salesforce_sandbox',
  SalesforceProduction = 'salesforce_production',
  ExchangeInline = 'exchange_inline',
}

export enum QuarantineRiskAILogTypeEnum {
  Exchange = 'exchange',
  ExchangeInline = 'exchangeInline',
  Gmail = 'gmail',
  GmailInline = 'gmailInline',
  All = 'riskAI',
}

export const QuarantineRiskAILogTypeMap = {
  [QuarantineRiskAILogTypeEnum.Exchange]: 'Exchange Online',
  [QuarantineRiskAILogTypeEnum.ExchangeInline]: 'Exchange Inline',
  [QuarantineRiskAILogTypeEnum.Gmail]: 'gmail',
  [QuarantineRiskAILogTypeEnum.GmailInline]: 'Gmail Inline',
} as const;

export type LogSearchFieldsType = {
  [key in LogTypeEnum]: SearchField[];
};

export interface TimeRangeInterface {
  predefined: LogTimeUnit;
  start: string;
  end: string;
  timezoneOffset?: string;
}

export interface DrillDownItem {
  predefined: LogTimeUnit;
  start: string;
  end: string;
  interval: string;
  timezoneOffset?: string;
}

export interface PageInterface {
  start: number;
  size: number;
}

export interface SortInterface {
  field: string;
  direction: string;
}

export interface Criterion {
  field: string;
  label: string;
  value: string;
  type: string;
  focus: boolean;
}

export interface SearchItem {
  field: string;
  values: string[];
  type: string;
  subType?: string;
}

export interface SearchField {
  field: string;
  type: string;
}

export interface SearchOptionItem {
  title: string;
  key: string;
}
export interface SearchCriteria {
  logType: string;
  criteria: Criterion[];
  setCriteria: Function;
  searchFields: SearchField[];
}
export interface LogParams {
  type: string;
  page: PageInterface;
  sort: SortInterface;
  timeRange: TimeRangeInterface;
  searches: string;
}

export interface LogData {
  contentList: any[];
  total: number;
}

export interface ColumnConfigInterface {
  order: string[];
  hideIds: string[];
}
export interface FacetSearch {
  filed: string;
  values: string[];
  type: string;
}
export interface LogFacetParams {
  type: string;
  searches: string;
  timeRange: TimeRangeInterface;
}
export interface FacetItem {
  key: string;
  count: number;
}
export interface AllFacets {
  [key: string]: FacetItem[];
}

export interface VirusLinks {
  [key: string]: string;
}

export type ChartDataItem = [string, number][];
export interface LogState {
  type: LogTypeEnum;
  criteria: Criterion[];
  facets: SearchItem[];
  allFacets: AllFacets;
  page: PageInterface;
  sort: SortInterface;
  timeRange: TimeRangeInterface;
  logs: any[];
  isLoading: boolean;
  isFacetLoading: boolean;
  total: number;
  columnConfig: ColumnConfigInterface;
  virusLinks: VirusLinks;
  l10nMap: { [key: string]: any };
  chartData: ChartDataItem[];
  isChartLoading: boolean;
  loadChart: string;
}

export interface SelectedItem {
  key: string;
  value: string;
  focus: boolean;
  label: string;
}

export type LogConfig = {
  [key in LogTypeEnum]: {
    key: string;
    showFields: string[];
    facets: string[];
    searchFields: string[];
    mergedFields: {
      [type: string]: string[];
    };
    wrapFields: string[];
  };
};
export interface QueryHistoryItem {
  type: string;
  criteria: Criterion[];
  timeRange: TimeRangeInterface;
  applied: string;
}

export interface VirusLinksParams {
  language: string;
}

export interface VaReportParams {
  language: string;
  reportId: string;
  ddaDetectionType: string;
  tmDDAaasAnalysisMode: string;
  tmFileName: string;
}

export interface LogChartParams {
  type: LogTypeEnum;
  timeRange: TimeRangeInterface;
  searches: string;
  interval: string;
}

export interface MailPreviewEnabledItem {
  enabled: boolean;
  orgId: string;
}

export enum LogModalNameEnum {
  DownloadVaReport = 'downloadVaReport',
  ManageColumn = 'manageColumn',
  Export = 'export',
  QueryHistory = 'queryHistory',
  None = 'none',
}
export type LogModalState =
  | {
      name: LogModalNameEnum.DownloadVaReport;
      data: VaReportParams;
    }
  | {
      name: LogModalNameEnum.ManageColumn;
      data: null; //read from log context
    }
  | {
      name: LogModalNameEnum.Export;
      data: null; //read from log context
    }
  | {
      name: LogModalNameEnum.QueryHistory;
      data: null; //read from log context
    }
  | {
      name: LogModalNameEnum.None;
      data: null;
    };

export enum SecurityFilterName {
  AdvancedSpamProtection = 'Advanced Spam Protection',
  MalwareScanning = 'Malware Scanning',
  VirtualAnalyzer = 'Virtual Analyzer',
  WebReputation = 'Web Reputation',
  FileBlocking = 'File Blocking',
  DLP = 'Data Loss Prevention',
  KeywordExtraction = 'Keyword Extraction',
  ContentFiltering = 'Content Filtering',
}

export interface LogFields {
  searchFields: SearchField[];
  facetsFields: string[];
  showFields: string[];
  mergedFields: {
    [type: string]: string[];
  };
  wrapFields: string[];
}
